<template>
    <div class="error-overlay">
        <div class="inner">
            <b>{{ msg }}</b>
            <P>Item must be removed and problem solved.<br>Ask manager for help.</P>
            <p><i>Please confirm that you removed the item!</i></p>
            <button type="button" @click="confirm">OK</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ErrorDialog",
        props: ['msg'],
        methods: {
            confirm() {
                this.$store.commit('clearErrorDialog');
            }
        }
    }
</script>

<style scoped>
    .error-overlay {
        position: absolute;
        top: 44px;
        left: 0;
        width: 100%;
        bottom: 0;
        opacity: 1;
        background-color: red;
        z-index: 5;
    }
    .error-overlay .inner {
        width: 90%;
        font-size: 120%;
        max-width: 500px;
        margin: 20vh auto 0 auto;
        border: solid 4px white;
        color: white;
        padding: 20px;
        text-align: center;
        border-radius: 15px;
        background-color: #a00;
        box-shadow: #222222 2px 2px 10px;
    }
    .error-overlay button {
        background: #eee;
        border-radius: 10px;
        padding: 10px 25px;
        font-size: 120%;
        font-weight: bold;
        cursor: pointer;
    }
</style>